module.exports = __webpack_public_path__ + "fonts/iconfont.26b189c9.ttf";